export default [
        {
            id: 1,
            title: "Shopping list",
            created: "October 02, 2021",
            category: "Task",
            content: "Need to buy bread, grape and cake",
            isArchived: false,
            dates: []
        },
        {
            id: 2,
            title: "The theory of ...",
            created: "October 02, 2021",
            category: "Random Thought",
            content: "Want to read",
            isArchived: true,
            dates: []
        },
        {
            id: 3,
            title: "New feature",
            created: "October 03, 2021",
            category: "Idea",
            content: "Implement new feature to 05.10.2021",
            isArchived: false,
            dates: ["05.10.2021"]
        },
        {
            id: 4,
            title: "William Gaddis",
            created: "October 01, 2021",
            category: "Quote",
            content: "Power doesn't corrupt people; people corrupt power.",
            isArchived: true,
            dates: []
        },
          {
            id: 5,
            title: "Books",
            created: "September 23, 2021",
            category: "Task",
            content: "The Lean Startup",
            isArchived: true,
            dates: []
        },
        {
            id: 6,
            title: "Deadline day",
            created: "October 03, 2021",
            category: "Task",
            content: "Must do 3 homeworks to 15.10.2021",
            isArchived: false,
            dates: ["15.10.2021"]
        },
        {
            id: 7,
            title: "Theodore Dreiser",
            created: "October 03, 2021",
            category: "Quote",
            content: "A thought will color a world for us.",
            isArchived: false,
            dates: []
        }
]